import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { urlGetFleetsToDepartureTime } from '../../routes/deliveries.routes'
import * as routes from '../../routes/deliveries.routes'

const InformacoesHorarioSaidaHttp = {
  async getFleetsToDepartureTime(tp_id) {
    try {
      const result = await authHttp().get(urlGetFleetsToDepartureTime(tp_id))
      return result.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveDepartureTimeFleetsInfo(selectedTp, data) {
    try {
      const response = await authHttp().put(routes.urlDepartureTimeFleetsInfo(selectedTp), data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default InformacoesHorarioSaidaHttp
